<script>
import { v4 as uuidv4 } from "uuid";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Swal from "sweetalert2";

export default {
  components: { DatePicker },
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      value: Array.isArray(this.item_value) ? this.item_value : [],
      isModalVisible: false,
      new_item: "",
      options: [],
      leveldisplay: true,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
      isValidationFailed: false,
      validationClass: {},
      rerender: true,
    };
  },
  methods: {
    validate() {
      this.rerender = false; // Disabling re-rendering temporarily
      console.log("validation called");
      this.validationClass = {}; // Resetting validation classes
      let validationFailed = false; // Flag to track any validation failures

      // Iterating over each schedule item
      this.item_value.forEach((sg, index) => {
        console.log("this.isStartDateLater(sg)", this.isStartDateLater(sg));

        if (
          sg.startDate !== "" &&
          sg.endDate !== "" &&
          this.isStartDateLater(sg)
        ) {
          validationFailed = true; // Mark validation as failed
          // Check if index already has a validation entry, if not initialize it
          this.validationClass[String(index)] =
            this.validationClass[String(index)] || {};
          this.validationClass[String(index)].endDate = true; // Mark specific index with validation issue for end date
        }

        if (
          sg.startDate !== "" &&
          sg.endDate !== "" &&
          sg.startDate === sg.endDate &&
          this.isStartTimeLater(sg)
        ) {
          validationFailed = true; // Mark validation as failed
          // Check if index already has a validation entry, if not initialize it
          this.validationClass[String(index)] =
            this.validationClass[String(index)] || {};
          this.validationClass[String(index)].endTime = true; // Mark specific index with validation issue for end time
        }
      });

      console.log("validationFailed", validationFailed);

      // Show error message if validation failed
      if (validationFailed) {
        Swal.fire(
          "Error",
          "The end date/time is before the start date/time. Please check and try again",
          "error"
        );
      }

      this.rerender = true; // Re-enabling re-rendering

      return !validationFailed; // Return the inverse of validationFailed to indicate success or failure
    },
    handlechangeStart(date) {
      console.log(date);
    },
    handlechangeEnd(date) {
      console.log(date);
    },
    isStartDateLater(event) {
      const startDate = new Date(
        event.startDate.split("/").reverse().join("-")
      );
      const endDate = new Date(event.endDate.split("/").reverse().join("-"));

      console.log(startDate, endDate);

      return startDate > endDate;
    },
    isStartTimeLater(event) {
      console.log(
        "event",
        event.startDate,
        event.endDate,
        event.startTime,
        event.endTime
      );

      // Check if start and end dates are the same
      if (event.startDate !== event.endDate) {
        console.log("Start and end dates are not the same.");
        return false; // Return false or handle differently if dates are not the same
      }

      // Continue with time comparison only if dates are the same
      const [startHours, startMinutes] = event.startTime.split(":").map(Number);
      const [endHours, endMinutes] = event.endTime.split(":").map(Number);

      // Compare hours first, then minutes if hours are the same
      if (startHours > endHours) {
        return true; // Start time is later
      } else if (startHours === endHours && startMinutes >= endMinutes) {
        return true; // Start time is same or later
      }

      return false; // Start time is earlier
    },
    disabledBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    validateEndTime(date, item) {
      const { startDate, endDate, startTime } = item;

      if (startDate === endDate) {
        let startTimeArray = startTime.split(":").map(Number);

        const [startHour, startMinute] = startTimeArray;
        // const [endHour, endMinute] = endTimeArray;
        const endHour = new Date(date).getHours();
        const endMinute = new Date(date).getMinutes();
        if (
          endHour < startHour ||
          (endHour === startHour && endMinute <= startMinute)
        ) {
          return true;
        }
      }
      return false;
    },
    toggleModal() {
      this.isModalVisible = !this.isModalVisible;
    },
    addPPG() {
      this.value.push({
        id: uuidv4(),
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
      });
    },
    removeItem(index) {
      this.value.splice(index, 1);
    },
  },
  computed: {
    level_two_display() {
      return this.display_none_check;
    },
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    item_value(newVal) {
      this.value = newVal;
      if (this.value.length === 0) {
        this.addPPG();
      }
    },
    selectedItem: {
      handler() {},
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
  async mounted() {
    console.log("Component mounted. Initial item_value:", this.item_value);
    this.value = this.item_value;
    if (this.value.length === 0) {
      this.addPPG();
    }
  },
};
</script>
<template>
  <div
    class="scheduler-input"
    :class="{ 'd-none': item.displayOn && !level_two_display }"
  >
    <b-modal
      v-model="isModalVisible"
      style="letter-spacing: 2em"
      id="add-ppg-newsletters"
      centered
      title="Add Item"
      title-class="font-18"
      hide-footer
    >
      <div class="d-flex mb-3">
        <input v-model="new_item" type="text" class="form-control mr-2" />
        <button
          class="btn btn-primary"
          @click="
            addPPG();
            $bvModal.hide('add-ppg-newsletters');
          "
        >
          Add
        </button>
      </div>
    </b-modal>
    <div class="full-width-flex">
      <div class="w100">
        <div class="section-label">{{ item.label }}</div>
        <div class="label-container">
          <div class="row w100">
            <div class="section-label col-3">{{ "Start Date" }}</div>
            <div class="section-label col-3">{{ "Start Time" }}</div>
            <div class="section-label col-3">{{ "End Date" }}</div>
            <div class="section-label col-3">{{ "End Time" }}</div>
          </div>
          <a
            class="font-size-14 mb-2 font-weight-medium ml-3 align-self-sm-center"
            role="button"
            style="color: transparent"
            >Remove</a
          >
        </div>
        <template v-if="rerender">
          <div v-for="(sg, index) in value" :key="sg.id" class="d-flex mb-2">
            <div class="row w100">
              <div class="input-section col-3">
                <date-picker
                  :class="{
                    'validation-failed': validationClass[String(index)]
                      ? validationClass[String(index)].startDate
                      : false,
                  }"
                  value-type="format"
                  v-model="sg.startDate"
                  type="date"
                  format="DD/MM/YYYY"
                  :disabled-date="disabledBeforeToday"
                  @change="(date) => handlechangeStart(date, sg)"
                ></date-picker>
              </div>
              <div class="input-section col-3">
                <date-picker
                  :class="{
                    'validation-failed': validationClass[String(index)]
                      ? validationClass[String(index)].startTime
                      : false,
                  }"
                  value-type="format"
                  v-model="sg.startTime"
                  type="time"
                  format="HH:mm"
                  :disabled-date="disabledBeforeToday"
                  :disabled-time="disabledBeforeToday"
                  @change="(date) => handlechangeStart(date, sg)"
                ></date-picker>
              </div>
              <div class="input-section col-3">
                <date-picker
                  :class="{
                    'validation-failed': validationClass[String(index)]
                      ? validationClass[String(index)].endDate
                      : false,
                  }"
                  value-type="format"
                  v-model="sg.endDate"
                  type="date"
                  format="DD/MM/YYYY"
                  :disabled-date="disabledBeforeToday"
                  @change="(date) => handlechangeEnd(date, sg)"
                ></date-picker>
              </div>
              <div class="input-section col-3">
                <date-picker
                  :class="{
                    'validation-failed': validationClass[String(index)]
                      ? validationClass[String(index)].endTime
                      : false,
                  }"
                  value-type="format"
                  v-model="sg.endTime"
                  type="time"
                  format="HH:mm"
                  :disabled-date="disabledBeforeToday"
                  :disabled-time="
                    (date) => {
                      return validateEndTime(date, sg);
                    }
                  "
                ></date-picker>
              </div>
            </div>
            <a
              class="font-size-14 mb-2 font-weight-medium ml-3 align-self-sm-center font-weight-medium"
              role="button"
              style="color: #da3f3f"
              v-on:click="removeItem(index)"
              >Remove</a
            >
          </div>
        </template>
        <div class="mt-2">
          <a
            class="font-size-14 mb-2 ml-auto align-self-sm-center cursor-pointer font-weight-medium"
            @click="addPPG()"
            >+ Add Item</a
          >
        </div>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
          <span v-if="!validation.required">This value is required.</span>
        </div>
        <portal-target :name="item_key"> </portal-target>
      </div>
    </div>
  </div>
</template>
<style>
.mx-time-column .mx-time-list::after {
  height: 10px;
}
.section-label {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #333;
  padding-bottom: 20px;
}
.blue-ray-section {
  width: 20px;
  height: auto;
  background: #cad9f6;
  margin-right: 30px;
}
.full-width-flex {
  display: inline-flex;
  width: 100%;
}
.w100 {
  width: 100%;
}
.pl-10 {
  padding-left: 10px;
}
.mr-1 {
  margin-right: 1px;
}
.mt-27 {
  margin-top: 27px;
}
.label-container {
  width: 100%;
  display: flex;
}
.label-container .section-label {
  padding-bottom: 10px;
  font-weight: 500;
}
.validation-failed .mx-input {
  border-color: red;
}
</style>
